export default Object.freeze({
  Post: 1,
  Get: 2,
  Put: 3,
  Delete: 4,
  Patch: 5,
});
